import React from 'react';
import { Field } from 'redux-form';
import range from 'lodash.range';
import cx from 'classnames';
import Input from '../Forms/Input';
import SelectField from '../Forms/SelectField';
import styles from './AdditionalInformationFields.css';
import required from '../../utils/fieldRequired';
import states from '../../../constants/states';

const emptyOption = {
    value: '',
    text: '',
    key: -1,
};

const militaryGraduationYears = range(2022, 1979).map(i => ({
    value: i,
    text: i,
    key: i,
}));

militaryGraduationYears.unshift(emptyOption);

const optionsForStates = Object.keys(states).map(value => ({
    value,
    text: value,
    key: value,
}));
optionsForStates.unshift(emptyOption);

const validateMobile = (value) => {
    if (!value || !/^\d{10}$/.test(value)) {
        return 'Please enter valid phone number';
    }
    return undefined;
};

const validateNumber = (value) => {
    if (!value || !/^\d+$/.test(value)) {
        return 'Please enter valid year';
    }
    return undefined;
};

const NustartAdditionalInformationFields = () => (<div>
    <div className={styles.row}>
        <Field
            name="mobilePhone"
            label="Mobile Phone *"
            component={Input}
            className={styles.input}
            validate={validateMobile}
        />
        <Field
            name="graduationYear"
            label="Graduation Year *"
            component={Input}
            className={styles.input}
            validate={validateNumber}
            options={militaryGraduationYears}
        />
    </div>
    <div className={styles.row}>
        <Field
            name="streetAddress"
            label="Street Address 1 *"
            component={Input}
            className={cx(styles.input, styles.size7)}
            validate={required}
        />
        <Field
            name="streetAddress2"
            label="Street Address 2"
            component={Input}
            className={cx(styles.input, styles.size7)}
        />
    </div>
    <div className={styles.row}>
        <Field
            name="city"
            label="City *"
            component={Input}
            className={cx(styles.input, styles.size6)}
            validate={required}
        />
        <Field
            name="state"
            label="State *"
            component={SelectField}
            className={cx(styles.input, styles.size6)}
            options={optionsForStates}
            validate={required}
        />
    </div>
</div>);

export default NustartAdditionalInformationFields;



// WEBPACK FOOTER //
// ./src/client/Components/ExtraUserInformation/NustartAdditionalInformationFields.js